import React from "react";
import { Link } from "react-router-dom";

const LOGO_INK = "https://static.prod-images.emergentagent.com/jobs/17006009-5ae1-416a-a126-519749023e8c/images/2f61edc0c0b0333d1078f103c657b241ec772ecd8e19e4ac459317a834914d8e.jpeg";

export const Footer = () => (
  <footer data-testid="footer" className="bg-ink px-6 py-16 text-cream md:px-12">
    <div className="mx-auto max-w-[1500px]">
      <div className="grid gap-12 border-b border-cream/15 pb-14 md:grid-cols-[2fr_1fr_1fr]">
        <div>
          <img src={LOGO_INK} alt="Southern Fried Peptides" className="h-44 w-44 object-contain" />
          <p className="mt-4 max-w-sm font-body text-sm leading-relaxed text-cream/60">
            Research-grade peptides, curated for women — third-party verified, purity-tested and COA-backed.
            Based in Southern Tennessee. Sold strictly for laboratory and research use only.
          </p>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-rust">Shop</p>
          <ul className="mt-5 space-y-3 font-body text-sm text-cream/70">
            <li><Link to="/#catalog" className="hover:text-cream">The Catalog</Link></li>
            <li><Link to="/#coa" className="hover:text-cream">Certificate of Analysis</Link></li>
            <li><Link to="/#manifesto" className="hover:text-cream">The Method</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-rust">Contact</p>
          <ul className="mt-5 space-y-3 font-body text-sm text-cream/70">
            <li>research@southernfriedpeptides.com</li>
            <li>Southern Tennessee · USA</li>
            <li>Mon–Fri, 9–5 CST</li>
          </ul>
        </div>
      </div>

      <div className="mt-8 rounded-none border border-ruo/60 bg-ruo/10 p-5">
        <p className="font-mono text-[11px] uppercase leading-relaxed tracking-[0.15em] text-cream/80">
          ⚠ Research Use Only. Products are NOT for human or veterinary use, not intended to diagnose, treat,
          cure, or prevent any disease, and not for consumption. By purchasing you certify you are a qualified
          researcher.
        </p>
      </div>

      <div className="mt-8 flex flex-col justify-between gap-3 font-mono text-[10px] uppercase tracking-[0.2em] text-cream/40 md:flex-row">
        <span>© 2026 Southern Fried Peptides Co.</span>
        <span>SOUTHERNFRIEDPEPTIDES.COM</span>
      </div>
    </div>
  </footer>
);
